import React from 'react'
import { LoaderContainer, LoaderContent, LoaderAnimation, LoaderMessage } from './styles'

import { LoadMessages } from './data.json'

function Loader() {
  const messageNumber = Math.floor(Math.random() * LoadMessages.length)

  return (
    <LoaderContainer>
      <LoaderContent>
        <LoaderAnimation />
        <LoaderMessage>{LoadMessages[messageNumber]}</LoaderMessage>
      </LoaderContent>
    </LoaderContainer>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/app/elements/Loader/index.js